export enum OrderResponseStatus {
  VALID = "valid",
  INVALID = "invalid",
  PENDING_REVIEW = "pending_review",
}
